import React, { useEffect, useState } from 'react'
import { Link as ScrollLink } from 'react-scroll'
import { Link } from 'react-router-dom';

const Header6 = ({ data, varient }) => {
  const { logo } = data;
  
  const {style} = data;
  const [mobileToggle, setMobileToggle] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [isSticky, setIsSticky] = useState(false);

  const handleMobileToggle = () => {
    setMobileToggle(!mobileToggle);
  };

  useEffect(() => {
    const handleScroll = () => {
      const windowTop = window.scrollY || document.documentElement.scrollTop;

      if (windowTop >= headerHeight) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
      setLastScrollTop(windowTop);
    };

    const headerHeight = document.querySelector('.st-sticky-header').offsetHeight;


    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isSticky, lastScrollTop]);

  return (
    <header className={`st-site-header st-style1 st-type2 st-color2 st-sticky-header ${isSticky ? "st-sticky-active" : ""}`}>
      <div className="st-main-header">
        <div className="container">
          <div className="st-main-header-in">
            <div className="st-main-header-left">
              <Link className="st-site-branding" to="/" style={{display:'flex',flexDirection:'row'}}>
                <img src={logo} alt={logo} style={style}/>
                <div style={{display:'flex',flexDirection:'column',justifyContent:"center",alignItems:'center',marginLeft:"20px"}}>
                  <span style={{fontWeight:'bold',color:'#000'}}>center dentaire</span>
                  <span style={{color:"#27b1d9",marginTop:"-5px"}}>ALYOUSSR</span>
                </div>
              </Link>
            </div>
            <div className="st-main-header-center">
              <div className="st-nav">
                <ul className={`st-nav-list st-onepage-nav ${mobileToggle ? "d-block" : "none"}`}>
                  <li>
                    <ScrollLink to="home" spy={true} duration={500} onClick={() => setMobileToggle(false)} >Accueil</ScrollLink>
                  </li>
                  <li>
                    <ScrollLink to="about" spy={true} duration={500} onClick={() => setMobileToggle(false)} >À propos </ScrollLink>
                  </li>
                  <li>
                    <ScrollLink to="service" spy={true} duration={500} onClick={() => setMobileToggle(false)} >Services</ScrollLink>
                  </li>
                  <li>
                    <ScrollLink to="contact" spy={true} duration={500} onClick={() => setMobileToggle(false)}>Contactez-Nous</ScrollLink>
                  </li>
                </ul>
                <div className={`st-munu-toggle ${mobileToggle ? "st-toggle-active" : ""} `} onClick={handleMobileToggle}>
                  <span></span>
                </div>
              </div>
            </div>
            <div className="st-main-header-right">
                <a className='st-btn st-style2 st-color3 st-size-medium' href="tel:+212663044661">
                  +2126 63 04 46 61
                </a>
            </div>
          </div>
        </div>
      </div>
    </header>

  )
}

export default Header6
